export const commonTexts = {
  noSensitiveInfo:
    "Ikke skriv sensitiv informasjon, for eksempel detaljerte opplysninger om helse.",
};
